
import { MediumBody } from "../Text";
import "./Card.scss";

interface ICardProps {
    title: string;
    children: React.ReactNode;
}

export const Card = ({ title, children }: ICardProps) => {
    return (
        <div className="card">
            <MediumBody className="card-title">{title}</MediumBody>
            <div className="card-content">{children}</div>
        </div>
    );
};